// extracted by mini-css-extract-plugin
export default {"resetPassword":"ResetPassword_resetPassword__-ZxyS"};